import { HintText } from '@lemonenergy/lemonpie-3'
import { Warning } from '@lemonenergy/lemonpie-icons'

type HintTextProps = {
  error?: string
}

const ErrorHintText = ({ error }: HintTextProps) => {
  if (!error) return undefined

  return (
    <div className="fg-critical h-main typography-caption gap-smallest px-smallest flex w-full items-center">
      <Warning size="small" />
      <HintText state="error">{error}</HintText>
    </div>
  )
}

export default ErrorHintText
